<wm-document-data-entity-view
  [activity]="activity"
  [application]="application"
  [entity]="entity"
></wm-document-data-entity-view>
